import React from 'react';
import { useGetDashboardQuery } from '@/store/api/dashboardApi';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { truncateText } from '@/utils';
export function DashboardPage() {
  // const { data } = useGetDashboardQuery();
  const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);
  const navigate = useNavigate();
  const { data, error, isLoading } = useGetDashboardQuery(undefined, {
    skip: !isAuthenticated,
  });

  const stats = [
    { title: 'Total Certificates', value: data?.stats?.totalCertificates },
    { title: 'Total Events', value: data?.stats?.totalEvents },
    { title: "Today's Certificates", value: data?.stats?.todaysCertificates },
    { title: 'Certificate Types', value: Object.keys(data?.stats?.certificateTypes || {}).length },
  ];

  const certificateTypes = data?.stats?.certificateTypes || {};

  const events = [
    {
      label: 'Participation',
      count: certificateTypes.Participation || 0,
      img: '/images/reward.svg',
    },
    {
      label: 'Training',
      count: certificateTypes.Training || 0,
      img: '/images/reward.svg',
    },
    {
      label: 'Achievement',
      count: certificateTypes.Achievement || 0,
      img: '/images/reward.svg',
    },
    {
      label: 'Appreciation',
      count: certificateTypes.Appreciation || 0,
      img: '/images/reward.svg',
    },
  ];
  const badgeColor = (type: string) => {
    switch (type) {
      case 'Participation':
        return 'bg-[#DAE6E3] border-[#28903E] text-[#28903E]';
      case 'Training':
        return 'bg-[#F6F5FF] border-[#B0A9F5] text-[#322890]';
      case 'Achievement':
        return 'bg-[#FFFBEA] border-[#E5CD6D] text-[#907B28]';
      case 'Appreciation':
        return 'bg-[#FFF6FF] border-[#804283] text-[#600265]';
      default:
        return 'bg-gray-500/20 text-gray-300';
    }
  };
  const formatDateTime = (date: string) => {
    const d = new Date(date);

    return d.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };
  return (
    <div className="lg:p-6 bg-black text-white space-y-6">
      <div className="grid md:grid-cols-3 gap-6">
        <div className="md:col-span-2 min-w-0">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-12 mb-4">
            {stats.map((item, i) => (
              <div
                key={i}
                className="rounded-xl overflow-hidden border border-[#DEE4E9] shadow-lg bg-primary-gradient"
              >
                <div className="bg-[#FFFFFF] rounded- text-black font-18 text-center py-1 font-medium relative z-10">
                  {item.title}
                </div>

                <div className=" text-center py-4 -mt-2 relative z-0">
                  <h2 className="text-xl font-medium">{item.value}</h2>
                </div>
              </div>
            ))}
          </div>
          <div className="bg-[#0b0b0f] border border-white/10 rounded-xl ">
            <div className="flex justify-between items-center mb-2 p-3">
              <h3 className="font-22 font-medium flex items-center gap-2">
                <span className="w-2.5 h-2.5 bg-[#00DA2C] rounded-full"></span>
                Recent Activity
              </h3>
              <span className="font-14 font-semibold text-[#8D90A0] bg-[#D4D6DD] px-2 py-1 rounded-full">
                Last 5
              </span>
            </div>
            <div className="border border-[#DEE4E9] rounded-xl mx-4 bg-primary-gradient overflow-x-auto">
              <div className="min-w-[900px]">
                <div className="grid grid-cols-5 font-14 font-semibold text-[#868686] px-6 py-4 bg-black rounded-t-xl border-b border-white/10">
                  <div className="">Certificate Title</div>
                  <div>Description</div>
                  <div className="text-center">Date</div>
                  <div className="text-center">Organization</div>
                  <div className="text-right">Certificate Type</div>
                </div>

                <div className="min-h-[150px]">
                  {(data?.recentActivity?.data?.length ?? 0) > 0 ? (
                    data?.recentActivity?.data?.map((item, i) => (
                      <div
                        key={i}
                        className="grid grid-cols-5 items-cen15er px-6 py-1.5 border-b border-[#DEE4E9] hover:bg-white/5 transition last:border-0"
                      >
                        <div className=" flex items-center gap-2 pr-4">
                          <img src="/images/reward.svg" alt="" className="w-6 h-7" />
                          <div className="">
                            <p className="font-14 font-semibold">{item.title}</p>
                          </div>
                        </div>
                        <div>
                          <Tooltip title={item.description} arrow>
                            <p className="font-14 font-semibold cursor-pointer">
                              {truncateText(item.description, 15)}
                            </p>
                          </Tooltip>
                        </div>

                        <div className="font-14 text-center  text-[#ffffff] font-semibold ">
                          {formatDateTime(item.date)}
                        </div>

                        <div className="font-14 text-[#ffffff] font-semibold  text-center">
                          {item.organization}
                        </div>

                        <div className="text-right">
                          <span
                            className={`font-14 font-medium px-2 py-1 rounded ${badgeColor(item.type || '')} border ${badgeColor(item.type || '').replace('bg-', 'border-')}`}
                          >
                            {item.type}
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="flex items-center justify-center h-[250px] text-[#8D90A0] font-16">
                      No recent activity found
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="justify-self-center mt-4">
              <button
                className=" px-4 py-1 rounded-[38px] font-14  flex items-center gap-2 
                                    bg-white/20 backdrop-blur-md 
                            border border-[#DEE4E9] shadow-lg hover:bg-white/30 transition-all duration-300 mb-4"
                onClick={() => navigate('/certificate-list')}
              >
                See More
              </button>
            </div>
          </div>
        </div>

        <div className="bg-[#0b0b0f] border border-white/10 rounded-xl p-4 h-full flex flex-col">
          <h3 className="font-22 font-semibold mb-4">Event</h3>

          <div className="grid grid-cols-2 gap-4 flex-1">
            {events.map((item, i) => (
              <div
                key={i}
                className="rounded-xl p-4 text-center relative border border-white/20 
          backdrop-blur-md bg-[linear-gradient(180deg,rgba(31,31,31,0.2)_0%,rgba(111,114,255,0.2)_100%)]
          shadow-[inset_0px_0px_4px_0px_rgba(255,255,255,0.4)]
          flex flex-col justify-center h-full"
              >
                <div
                  className={`font-14 absolute top-2 right-2 px-2 py-1 rounded border ${badgeColor(item.label)}`}
                >
                  {item.label}
                </div>

                <img src={item.img} alt="" className="mx-auto my-4 lg:my-0 pt-4 lg:pt-0" />

                <div className="text-2xl font-bold">{String(item.count).padStart(2, '0')}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
